export default {
    props: {
        numberOfScreens: Number
    },
    data() {
        return {
            screen1Height: 0,
            screen2Height: 0,
            maxGameContainerHeight: 0,
            screensUrlParam: null,
            screen1UrlParam: null,
            screen2UrlParam: null,
        };
    },
    methods: {
        getDisplayScreenQueryParams() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            this.screensUrlParam = urlParams.get('screens');
            this.screen1UrlParam = urlParams.get('screen_1');
            this.screen2UrlParam = urlParams.get('screen_2');
        },
        calculateScreenHeight() {
            if (this.numberOfScreens === 1) {
                return;
            }

            this.getDisplayScreenQueryParams();

            const navbar = document.getElementById('navigation');
            const navbarOffsetHeight = navbar !== null ? navbar.offsetHeight : 0;
            const heightOffset = 0.5;
            /** @info 40 because we use padding top 20px and bottom 20px inside games container */
            const gamesContainerPaddingHeightOffset = 40;

            const expectedUrlResolutionPattern = /^\d+(\.\d+)?x\d+(\.\d+)?$/;

            if (
                this.screen1UrlParam
                && this.screen2UrlParam
                && expectedUrlResolutionPattern.test(this.screen1UrlParam)
                && expectedUrlResolutionPattern.test(this.screen2UrlParam)
            ) {
                const [screen1Width, screen1Height] = this.screen1UrlParam.split('x').map(Number);
                const [screen2Width, screen2Height] = this.screen2UrlParam.split('x').map(Number);
                this.screen1Height = screen1Height - heightOffset;
                this.screen2Height = screen2Height - navbarOffsetHeight - heightOffset;
                this.maxGameContainerHeight = screen2Height - navbarOffsetHeight - gamesContainerPaddingHeightOffset - heightOffset;
                return;
            }

            const halfScreenHeight = window.innerHeight / this.numberOfScreens;
            this.screen1Height = halfScreenHeight - heightOffset;
            this.screen2Height = halfScreenHeight - navbarOffsetHeight - heightOffset;
            this.maxGameContainerHeight = halfScreenHeight - navbarOffsetHeight - gamesContainerPaddingHeightOffset - heightOffset;
        },
    },
};
